var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        height: 900,
        width: 2210,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: { height: "20", width: "300", y: "15", x: "0", rx: "5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "40", width: "120", y: "15", x: "2090", rx: "5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "76", width: "2210", y: "62", x: "0", rx: "5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "76", width: "2210", y: "155", x: "0", rx: "5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "76", width: "2210", y: "251", x: "0", rx: "5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "76", width: "2210", y: "344", x: "0", rx: "5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "76", width: "2210", y: "441", x: "0", rx: "5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "76", width: "2210", y: "536", x: "0", rx: "5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "76", width: "2210", y: "631", x: "0", rx: "5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "76", width: "2210", y: "725", x: "0", rx: "5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "76", width: "2210", y: "815", x: "0", rx: "5" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }